import { apiFetch } from './client';

export interface MeProfile {
  id: string;
  phoneE164: string;
  email: string | null;
  displayName: string;
  userType: string;
  status: string;
  enterpriseId: string | null;
  registeredAt: string;
  aiDisclaimerAckedAt: string | null;
}

export interface LoginHistoryItem {
  id: string;
  at: string;
  ip: string | null;
  city: string | null;
  result:
    | 'success'
    | 'fail_not_found'
    | 'fail_wrong_password'
    | 'fail_locked'
    | 'fail_anomaly';
}

export const usersApi = {
  me: () => apiFetch<MeProfile>('/users/me'),
  update: (patch: { displayName?: string; email?: string | null }) =>
    apiFetch<{ id: string; email: string | null; displayName: string }>(
      '/users/me',
      { method: 'PATCH', body: JSON.stringify(patch) },
    ),
  close: () =>
    apiFetch<{ ok: boolean; scheduledFor: string; message: string }>('/users/me/close', {
      method: 'POST',
    }),
  loginHistory: () => apiFetch<LoginHistoryItem[]>('/users/me/login-history'),
  revokeAllSessions: () =>
    apiFetch<{ ok: boolean; revokedAt: string; message: string }>(
      '/users/me/revoke-all-sessions',
      { method: 'POST' },
    ),
  anomalies: () => apiFetch<LoginAnomalyItem[]>('/users/me/anomalies'),
  ackAnomaly: (id: string) =>
    apiFetch<{ ok: boolean }>(`/users/me/anomalies/${id}/ack`, { method: 'POST' }),
  ackAiDisclaimer: () =>
    apiFetch<{ ok: boolean; ackedAt: string }>('/users/me/ai-disclaimer/ack', { method: 'POST' }),
};

export interface LoginAnomalyItem {
  id: string;
  ipAtLogin: string | null;
  previousIp: string | null;
  previousAt: string;
  detectedAt: string;
  ackedAt: string | null;
}
